<template>
  <div>
    <!-- <button class="mylisting-button dark-button" @click="updateJobs()">Update Jobs</button> -->

    <table class="table table-striped mt-2">
      <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
        <tr class="">
          <th scope="col">Title</th>
          <th scope="col">Client</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="job in jobs" :key="job.id" style="cursor: pointer;">
        <!-- <tr v-for="user in filteredCandidates" :key="user.id" @click="deleteUser(user.id)" style="cursor: pointer;"> -->
          <td>
            {{ job.title }}
          </td>
          <td>
            {{ job.poster_name }}
            <!-- {{ job.job_type }} -->
            <!-- {{ user.status }} -->
          </td>
          <td>
            {{ job.status }}
            <!-- <button class="btn btn-danger" @click="deleteUser(user)">Delete</button> -->
            <!-- <button class="btn btn-danger" @click="setteam(user)">Set Team Status</button> -->
            <!-- <button class="mylisting-button dark-button" @click="unadminify(user)">Unadminify</button> -->
            <!-- <button class="mylisting-button dark-button" @click="setCategory(user)">Set Category</button> -->
            <!-- <button class="mylisting-button dark-button" @click="setPassword(user)">Set Password</button> -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      jobs: [],
    }
  },
  created() {
    this.getJobs()
  },
  methods: {
    getJobs() {
      axios.get(`/api/jobs/?agency=${this.$store.getters.agencyID}`)
        .then(res => {
          console.log(res.data)

          this.jobs = res.data
          this.jobs = this.jobs.sort((a, b) => (a.id < b.id) ? 1 : -1)
        })
        .catch(error => console.log(error))
    },

    updateJobs() {
      for (const job of this.jobs) {
        if (job.job_type != 'Long Term') {
          axios.patch(`/api/jobs/${job.id}/`, {
            job_type: "Long Term",
          })
            .then(res => {
              console.log(res)
            })
            .catch(error => {
              console.log(error)
            })
        }
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/agents/tables/Jobs.vue